import React, {useState} from 'react';
import {Link} from 'react-router-dom';

/**
 * Development navigation component for testing all routes.
 * Only visible in development mode.
 */
export const DevNav: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    const navStyle: React.CSSProperties = {
        position: 'fixed',
        top: 0,
        left: isOpen ? 0 : -280,
        width: '280px',
        height: '100vh',
        backgroundColor: '#2c3e50',
        color: '#ecf0f1',
        overflowY: 'auto',
        transition: 'left 0.3s ease',
        zIndex: 9999,
        padding: '20px',
        boxShadow: '2px 0 10px rgba(0,0,0,0.3)',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px'
    };

    const toggleButtonStyle: React.CSSProperties = {
        position: 'fixed',
        top: '10px',
        left: isOpen ? '290px' : '10px',
        backgroundColor: '#3498db',
        color: 'white',
        border: 'none',
        padding: '10px 15px',
        cursor: 'pointer',
        borderRadius: '4px',
        zIndex: 50000,
        transition: 'left 0.3s ease',
        fontSize: '14px',
        fontWeight: 'bold'
    };

    const categoryStyle: React.CSSProperties = {
        marginTop: '20px',
        marginBottom: '10px'
    };

    const categoryTitleStyle: React.CSSProperties = {
        color: '#3498db',
        fontSize: '12px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '8px'
    };

    const linkStyle: React.CSSProperties = {
        display: 'block',
        color: '#ecf0f1',
        textDecoration: 'none',
        padding: '8px 12px',
        marginBottom: '4px',
        borderRadius: '4px',
        transition: 'background-color 0.2s',
        fontSize: '13px'
    };

    const linkHoverStyle: React.CSSProperties = {
        backgroundColor: '#34495e'
    };

    const routes = {
        'Authentication & Access': [
            {path: '/login', label: 'Login'},
            {path: '/login-callback', label: 'Login Callback'},
            {path: '/changePassword', label: 'Change Password'},
            {path: '/guest', label: 'Guest'},
            {path: '/browser-not-supported', label: 'Browser Not Supported'}
        ],
        'SSO Actions': [
            {path: '/reactivate-account', label: 'Reactivate Account'},
            {path: '/revoke-account', label: 'Revoke Account'}
        ],
        'Dashboard & NWay': [
            {path: '/dashboard', label: 'Dashboard'},
            {path: '/dashboard/entry', label: '  → Entry'},
            {path: '/dashboard/main', label: '  → Main'},
            {path: '/dashboard/store', label: '  → store'},
            {path: '/multipartyDashboard', label: 'Multiparty Dashboard'},
            {path: '/emb-dashboard-error', label: 'Embedded Dashboard Error'},
            {path: '/nway', label: 'NWay Participant'}
        ],
        Invite: [
            {path: '/invite', label: 'Invite'},
            {path: '/invite/connectivity-check', label: '    → Connectivity Check'},
            {path: '/history', label: '    → History'}
        ],
        'Join & Session End': [
            {path: '/join', label: 'Join'},
            {path: '/session-ended', label: 'Session Ended'},
            {path: '/invitation-ended', label: 'Invitation Ended'}
        ],
        'History & Reports': [
            {path: '/vj-history', label: 'VJ History'},
            {path: '/wifiAnalyzerHistory', label: 'WiFi Analyzer History'}
        ],
        'Connectivity & Diagnostics': [
            {path: '/connectivity-self-check', label: 'Connectivity Self Check'},
            {path: '/connectivity-guru-data', label: 'Connectivity Guru Data'}
        ]
    };

    return (
        <>
            <button
                style={toggleButtonStyle}
                onClick={() => setIsOpen(!isOpen)}
                title={isOpen ? 'Close Nav' : 'Open Nav'}>
                {isOpen ? '◀' : '▶'} Routes
            </button>
            <nav style={navStyle}>
                <h2 style={{marginTop: 0, marginBottom: '10px', fontSize: '16px', color: '#3498db'}}>
                    🧭 Dev Navigation
                </h2>
                <p style={{fontSize: '11px', color: '#95a5a6', marginBottom: '20px'}}>Test all application routes</p>
                {Object.entries(routes).map(([category, links]) => (
                    <div key={category} style={categoryStyle}>
                        <div style={categoryTitleStyle}>{category}</div>
                        {links.map((route) => (
                            <Link
                                key={route.path}
                                to={route.path}
                                style={linkStyle}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = linkHoverStyle.backgroundColor!;
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }}>
                                {route.label}
                            </Link>
                        ))}
                    </div>
                ))}
            </nav>
        </>
    );
};
